import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { history } from '../routers/AppRouter';
// import { clearAuthError } from '../actions/auth';
import isEmail from 'validator/lib/isEmail';
// import getAppConfigParm  from '../config/AppConfig';


// This form is simply responsible for presenting the form, validating inputs, saving form data in 
// local state, and passing the form data to the onSubmit function prop that was passed in from parent.
// Goal is to keep track of local state for all of the inputs. Only when form has been validated successfully
// within the local onSubmit, do we want to dispatch an action. This action will be dispatched by the parent.
// If there are any form errors, the formError property (within the component state) will be set and
// the onSubmit passed from the parent component will not be called.
// If there are any authentication or api call errors (from the action that was dispatched from parent), 
// it will be logged as an auth.error on the redux store. The displayError() method will check if
// either form error or auth error exists. If so, it shows the error message on top of the form. The 
// local Form error property will be reset to null (thru isValidForm method) when form is resubmitted with no errors. The auth error
// The auth.error property, on redux store will, be reset when user logs in successfully (via startlogin action)
// or when the component unmounts (via componentWillUnmount).
class ForgotPwForm extends React.Component {
    constructor(props) {
        super(props);
    
        // local component state
        this.state = {
            email:              props.formData ? props.formData.email : '',
            formError: ''
            // justMounted: false
        };
    }

   componentDidMount = () => {
       this.setState({justMounted: true})
   }
    
    // -----------------------------------------------------------
    // Form events
    // -----------------------------------------------------------

    onEmailChange = (e) => {
        const email = e.target.value.trim();     // assign input value to email; allows to use object shorthand on next line
        this.setState(() => ({ email })); // update email on local state using ES6 shorthand
    };

    // Note: this local onSubmit method does form validation, but does not dispatch the 
    // action responsible for logging in user and saving auth token. 
    // The dispatch is done by the onSubmit method passed in as a function prop, from the 
    // Parent page. The function prop (this.props.onSubmit) is invoked with data needed 
    // for the Parent page to decide if and when an action is dispatched.
    onSubmit = (e) => {
        // let self = this;
        e.preventDefault();

        // If no errors on the form, call the onSubmit method on parent component, which 
        // dispatches the startLogin action, which logins user, sets isAuthenticated, and
        // saves token.
        if (this.isValidForm()) {
            this.props.onSubmit({
                email: this.state.email
            });
        }; 
    };

    // -----------------------------------------------------------
    // On click handlers
    // -----------------------------------------------------------

    // Take user back to login page
    handleCancel = () => {
        history.push("/login");
    }
 
    // -----------------------------------------------------------
    // Render method
    // -----------------------------------------------------------

    render() {
        return (
            <form className="form-forgotpw" onSubmit={this.onSubmit}>
                {this.displayError()}   
                <h3 className="modalstyle__title"> Forgot Password?</h3>
                <h5 className="modalstyle__subtitle">
                   No problem. Provide email address below then check your
                   inbox for email with instructions.
                </h5>
                <input 
                    type="text"
                    placeholder="Email address"
                    className="modalstyle__field"
                    onChange={this.onEmailChange}    // change the state.email value vi on change method
                    value={this.state.email}         // render component with value from state object
                />
                <div>
                  <button type="button" className="button-shadow button--oval" 
                          onClick={this.handleCancel} >
                    Cancel
                  </button> 
                  <span> &nbsp; &nbsp;</span>
                  <button className="button button--oval">Send</button> 
                </div>
            </form>
        )
    }

    // -----------------------------------------------------------
    // Helper functions
    // -----------------------------------------------------------

    // It will check if a local form error exist first, and render error message.
    // If not, it checks for an auth error exist (eg. email is valid but is registed in the database). 
    // If this is the case, it comes as an auth.error 
    displayError = () => {
        if (this.state.formError) {
            return <p className="error" style={{marginBottom: '1rem'}}>{this.state.formError}</p>
        }
        if (this.props.auth.error) {
            return <p className="error" style={{marginBottom: '1rem'}}>{this.props.auth.error}</p>
        }
    }
  
    isValidForm = () => {
        let valid = false;
        if (!this.state.email || !isEmail(this.state.email)) {
            this.setState(() => ({ formError: 'Please provide valid email address'}))
        } else {
            this.setState(() => ({ formError: ''}));
            valid = true;
        }
        return valid;
    }
   
} // END OF REACT component


// -----------------------------------------------------------
// Redux functions
// -----------------------------------------------------------

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    };
};

const mapDispatchToProps = (dispatch) => ({
    clearAuthError:     () => dispatch(clearAuthError()),
    sendResetPwMail:   () => dispatch(sendPwResetEmail(email))
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPwForm);


// {this.state.formError && <p className="form__error">{this.state.formError}</p>}
//             {this.props.auth.error && <p className="form__error">{this.props.auth.error}</p>}rops.auth.error && <p className="form__error">{this.props.auth.error}</p>}h.error && <p className="form__error">{this.props.auth.error}</p>}


// WEBPACK FOOTER //
// ./src/components/ForgotPwForm.js